import { createEntityAdapter } from '@reduxjs/toolkit';
import { FlightParams } from './flights.types';

const adapter = createEntityAdapter<FlightParams>();

export default adapter;
